module.exports = false;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0